function initMap(sectionEl) {
  const mapDiv = sectionEl.querySelector('.map-locations__map');
  if (!mapDiv || mapDiv._mapInitialized) return;
  mapDiv._mapInitialized = true;

  const locations = JSON.parse(mapDiv.dataset.locations || '[]')
    .map((loc) => {
      const parts = (loc.coordinates || '').split(',').map((s) => parseFloat(s.trim()));
      return { ...loc, lat: parts[0], lng: parts[1] };
    })
    .filter((loc) => !isNaN(loc.lat) && !isNaN(loc.lng));
  if (!locations.length) return;

  const style = getComputedStyle(sectionEl);
  const pinColor = `rgb(${style.getPropertyValue('--color-button').trim() || '0, 124, 248'})`;
  const strokeColor = `rgb(${style.getPropertyValue('--color-foreground').trim() || '13, 12, 12'})`;

  const map = new maplibregl.Map({
    container: mapDiv,
    style: 'https://tiles.openfreemap.org/styles/positron',
    center: [0, 0],
    zoom: 2,
    scrollZoom: false,
  });

  map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-right');

  map.on('load', () => {
    const bounds = new maplibregl.LngLatBounds();

    locations.forEach((loc) => {
      const markerEl = document.createElement('div');
      markerEl.className = 'map-marker';
      markerEl.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 36" width="24" height="36" style="overflow:visible;display:block;">
        <path d="M12 0C5.4 0 0 5.4 0 12c0 9 12 24 12 24s12-15 12-24C24 5.4 18.6 0 12 0z"
          fill="${pinColor}" stroke="${strokeColor}" stroke-width="1.5" stroke-linejoin="round"/>
        <circle cx="12" cy="12" r="4" fill="white" fill-opacity="0.85"/>
      </svg>`;

      let popupHTML = `<strong>${loc.name}</strong>`;
      if (loc.address) popupHTML += `<p><a href="https://www.google.com/maps/search/${encodeURIComponent(loc.address)}/@${loc.lat},${loc.lng},16z" target="_blank" rel="noopener">${loc.address}</a></p>`;
      if (loc.description) popupHTML += `<p>${loc.description}</p>`;
      if (loc.website_url) popupHTML += `<a href="${loc.website_url}" target="_blank" rel="noopener">Besøg hjemmeside</a>`;

      const popup = new maplibregl.Popup({ offset: 44, closeButton: false })
        .setHTML(popupHTML);

      new maplibregl.Marker({ element: markerEl, anchor: 'bottom' })
        .setLngLat([loc.lng, loc.lat])
        .setPopup(popup)
        .addTo(map);

      bounds.extend([loc.lng, loc.lat]);
    });

    if (locations.length === 1) {
      map.jumpTo({ center: [locations[0].lng, locations[0].lat], zoom: 13 });
    } else {
      map.fitBounds(bounds, { padding: 60, animate: false });
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.map-locations').forEach(initMap);
});

document.addEventListener('shopify:section:load', (e) => {
  const section = e.target.querySelector('.map-locations') || e.target;
  if (typeof maplibregl !== 'undefined') initMap(section);
});
